import { ATTENDANCE_MANAGEMENT_EN_US } from "#pages/place/bars/attendance-management/translations/attendance-management-en-us";
import { BarsAndSectorsTranslations } from "./bars-and-sectors-pt-br";

export const BARS_AND_SECTORS_EN_US: BarsAndSectorsTranslations = {
	title: "Bars",
	description: "Manage and customize inventory, printer and menu settings for bars.",
	barsAndSectors: "Bars and Sectors",
	bars: "Bars",
	sectors: "Sectors",
	generalSettings: "General Settings",
	printByTableSettings: "Environment and Table Configuration",
	attendanceManagement: ATTENDANCE_MANAGEMENT_EN_US,
	editSector: "Edit Sector",
	createSector: "Create Sector",
	createNewSector: "Create New Sector",
	newSector: "New Sector",
	searchPlaceholderSector: "Search by sector or bar name",
	searchPlaceholderAccess: "Search by access name",
	sectorName: "Sector Name",
	sectorBars: "Sector Bars",
	accessControl: "Access Control",
	createAccess: "Create Access",
	newAccess: "New Access",
	editAccess: "Edit Access",
	createNewAccess: "Create New Access",
	accessName: "Access Name",
	initialDate: "Start",
	endDate: "End",
	range: "Range of ZigCards",
	zigCardsId: "ZigCard ID",
	downloadModel: "Download the model file",
	selectFile: "Select a file",
	selectFileDescription: "File type [.xlsx, .xls] up to [500 mb].",
	removeFile: "Remove file",
	createAccessSuccess: "Access created successfully",
	editAccessSuccess: "Access edited successfully",
	name: "Name",
	initialDateHour: "Initial date and time",
	endDateHour: "End date and time",
	deleteSector: "Delete sector",
	deleteSectorSubtitle: "Are you sure you want to delete the sector?",
	deleteSectorSuccess: "Sector deleted successfully",
	editSectorSuccess: "Sector edited successfully",
	createSectorSuccess: "Sector created successfully",
	deleteAccessPolicy: "Delete access",
	deleteAccessPolicySubtitle: "Are you sure you want to delete the access?",
	deleteAccessPolicySuccess: "Access deleted successfully",
	editAccessPolicySuccess: "Access edited successfully",
	createAccessPolicySuccess: "Access created successfully",
	importAccessPolicyTagsSuccess: "Ids imported successfully",
	accesses: "Accesses",
	sectorAccesses: "Sector Accesses",
	modelFileName: "spreadsheet-model",
	noSectors: "No sectors registered",
	tagIdsError: "Add at least one ZigCard ID",
	onlySpacesError: "Field cannot contain only spaces",
	seeZigCards: "See ZigCards",
};
